import PBService from "@irati/utils/services"
import client, {QueryOptions, MutationOptions} from "@irati/utils/services/apollo"
import {DateInput} from "@irati/types"

import createOrganisation from "./mutations/createOrganisation"
import workOSPortalLinks, {workOSPortalLinksKey} from "./queries/workOSPortalLinks"
import workOSOrganisation, {workOSOrganisationKey} from "./queries/workOSOrganisation"
import workOSUser, {workOSUserKey} from "./queries/workOSUser"
import workOSLinkCode, {workOSLinkCodeKey} from "./mutations/workOSLinkCode"
import workOSLinksFromCode, {workOSLinksFromCodeKey} from "./queries/workOSLinksFromCode"
import workOSDsyncConfig, {workOSDsyncConfigKey} from "./queries/workOSDsyncConfig"
import setWorkOSDsyncConfig, {setWorkOSDsyncConfigKey} from "./mutations/setWorkOSDsyncConfig"
import deleteSSOUserMutation from "./mutations/deleteSSOUser"

class Service extends PBService {
  createOrganisation = (businessId: string, options: MutationOptions = {}) => {
    const variables = {businessId}
    return client
      .mutate({
        ...options,
        mutation: createOrganisation,
        variables
      })
      .then(() => {
        return this.getOrganisation(businessId, {fetchPolicy: "network-only"})
      })
  }
  generatePortalLinks = (businessId: string, options: QueryOptions = {}) => {
    const variables = {businessId}
    return client.query({...options, query: workOSPortalLinks, variables}).then(({data}) => {
      return data[workOSPortalLinksKey]
    })
  }
  getOrganisation = (businessId: string, options: QueryOptions = {}) => {
    const variables = {businessId}
    return client.query({...options, query: workOSOrganisation, variables}).then(({data}) => {
      return data[workOSOrganisationKey]
    })
  }
  getUser = (userId: string, options: QueryOptions = {}, extraVariables: {}) => {
    const variables = {userId, ...extraVariables}
    return client.query({...options, query: workOSUser, variables}).then(({data}) => {
      return data[workOSUserKey]
    })
  }
  generateSetupLinkCode = (businessId: string, options: QueryOptions = {}) => {
    const variables = {businessId}
    return client.mutate({...options, mutation: workOSLinkCode, variables}).then(({data}) => {
      return data[workOSLinkCodeKey]
    })
  }
  generateSetupLinksFromCode = (code: string, options: QueryOptions = {}) => {
    const variables = {code}
    return client.query({...options, query: workOSLinksFromCode, variables}).then(({data}) => {
      return data[workOSLinksFromCodeKey]
    })
  }
  getDsyncConfig = (businessId: string, options: QueryOptions = {}) => {
    const variables = {businessId}
    return client.query({...options, query: workOSDsyncConfig, variables}).then(({data}) => {
      return data[workOSDsyncConfigKey]
    })
  }
  setDsyncConfig = (businessId: string, launchAt: DateInput, options: QueryOptions = {}) => {
    const variables = {businessId, launchAt}
    return client.mutate({...options, mutation: setWorkOSDsyncConfig, variables}).then(({data}) => {
      return data[setWorkOSDsyncConfigKey]
    })
  }
  deleteSSOUser = (userId: string) => {
    return client.mutate({mutation: deleteSSOUserMutation, variables: {userId}})
  }
}

const service = new Service({errorHandlers: []})

export default service
